import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

export default function Gallery() {
  const [big, ...rest] = SITE.gallery;
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14 md:mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="md:col-span-12 font-display text-4xl md:text-6xl tracking-tighter leading-[0.98]"
          >
            Nanded ka sabse well-stocked electrical store.{" "}
            <span className="italic font-light text-white/60">
              Aao, khud dekho.
            </span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {/* Wide hero image spanning full width, 4:3 aspect */}
          <GalleryCard item={big} idx={0} wide />
          {rest.map((item, i) => (
            <GalleryCard key={item.title} item={item} idx={i + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}

function GalleryCard({ item, idx, wide = false }) {
  return (
    <motion.figure
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.9, delay: idx * 0.06, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`gallery-card-${idx}`}
      className={`group relative overflow-hidden rounded-[26px] border border-white/[0.06] bg-[#111] ${
        wide ? "col-span-2 aspect-[4/3]" : "aspect-[4/5]"
      }`}
    >
      <img
        src={item.img}
        alt={item.title}
        className="absolute inset-0 h-full w-full object-contain bg-[#111] group-hover:scale-[1.03] transition-transform duration-[900ms] ease-out"
        loading="lazy"
      />
      {/* Subtle bottom gradient for label legibility */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/80 to-transparent pointer-events-none" />
      <figcaption className="absolute inset-x-0 bottom-0 p-4 md:p-6">
        <h3 className="font-display text-lg md:text-2xl tracking-tight text-white">
          {item.title}
        </h3>
        <p className="text-white/70 text-xs md:text-sm mt-0.5">{item.sub}</p>
      </figcaption>
    </motion.figure>
  );
}
